import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { Cookies } from 'react-cookie';

import { fetchJSON } from '../../../helpers/api';

import * as types from './constants';

import apiConfig from '../../../config/routesApi';

import * as Actions from './actions';

var i = 0, j = 0, z = 0, y = 0, c = 0, a = 0;
const delay = (ms) => new Promise(res => setTimeout(res, ms));
const cookie = new Cookies();
const user_token = cookie.get("user_access");

var options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + (user_token ? (typeof user_token == 'object' ? user_token.access_token : JSON.parse(user_token).access_token) : '') }
    //+ (user_token ? (typeof user_token == 'object' ? user_token.access_token : JSON.parse(user_token).access_token) : '')
};

function* dataUserSupervisor() {
    options.method = 'GET';
    options.body = null;
    try {
        if (i === 0) {
            let list = [];
            i++;
            const response = yield call(fetchJSON, apiConfig.apiGateway.authen + apiConfig.apiSupervisor.list, options);
            if (response.header.code === 200) {
                response.items.forEach(element => {
                    element.id = element.userId;
                    element.label = element.fullName + ' (' + element.username + ')';
                    list.push(element);
                });
            }
            else {
                list = ["null"];
            }
            yield put(Actions.getDataSupervisor(list));
            yield delay(500);
            i = 0;
            yield delay(1);
            yield put(Actions.resetLoading());
        }
    }
    catch (error) {
        yield put(Actions.getDataSupervisor(["null"]));
        yield delay(5000);
        yield put(Actions.resetLoading());
    }
}

function* filterSupervisor({ formData: data }) {
    options.method = 'POST';
    options.body = JSON.stringify(data);
    try {
        if (j === 0) {
            let list = [];
            j++;
            const response = yield call(fetchJSON, apiConfig.apiGateway.authen + apiConfig.apiSupervisor.filter, options);
            if (response.header.code === 200) {
                list = response.items;
            }
            else {
                list = ["null"];
            }
            yield put(Actions.loadSupervisorByFilter(list));
            yield delay(500);
            j = 0;
            yield delay(7000);
            yield put(Actions.resetLoading());
        }
    }
    catch (error) {
        yield put(Actions.loadSupervisorByFilter(["null"]));
    }
}

function* editSupervisor({ formData: data, id }) {
    options.body = JSON.stringify(data);
    options.method = 'PUT';
    if (c === 0) {
        c++;
        const response = yield call(fetchJSON,apiConfig.apiGateway.authen + apiConfig.apiSupervisor.edit + id, options);

        if (response.header.code === 200 || response.header.code === 201) {
            yield put(Actions.submitSucceed(response.message));
            yield put(Actions.getDataSupervisor([]));
        }
        else {
            yield put(Actions.submitFailed(response.message));
        }
        yield delay(500);
        c = 0;
    }
}

function* deleteSupervisor({ id }) {
    options.body = null;
    options.method = 'DELETE';
    if (z === 0) {
        z++;
        const response = yield call(fetchJSON, apiConfig.apiGateway.authen + apiConfig.apiSupervisor.delete + id, options);

        if (response.header.code === 200 || response.header.code === 201) {
            yield put(Actions.submitSucceed(response.message));
            yield put(Actions.getDataSupervisor([]));
        }
        else {
            yield put(Actions.submitFailed(response.message));
        }
        yield delay(500);
        z = 0;
    }
}

export function* watchUserSupervisor() {
    yield takeEvery(types.GET_DATA_SUPERVISOR, dataUserSupervisor);
}

export function* watchSupervisorFilter() {
    yield takeEvery(types.FILTER_SUPERVISOR, filterSupervisor);
}

export function* watchSupervisorEdit() {
    yield takeEvery(types.EDIT_SUPERVISOR, editSupervisor);
}
export function* watchSupervisorDelete() {
    yield takeEvery(types.DELETE_SUPERVISOR, deleteSupervisor);
}

function* userSupervisorSaga() {
    yield all([
        fork(watchUserSupervisor),
        fork(watchSupervisorFilter),
        fork(watchSupervisorEdit),
        fork(watchSupervisorDelete)
    ]);
}

export default userSupervisorSaga;
